import type { MerchantUserFeeResponce } from 'store/models';

import { percentage, subtract, sum, truncateNumber } from './math/math';

export interface UserFeeCalculation {
  userFeeAmount: number;
  amountAfterUserFee: number;
}

export const calculateUserFee = (
  amount: number,
  merchantUserFee?: MerchantUserFeeResponce | null,
  currencyPrecision?: number,
): UserFeeCalculation => {
  if (!Number.isFinite(amount)) {
    return {
      userFeeAmount: 0,
      amountAfterUserFee: amount,
    };
  }

  if (!merchantUserFee?.percentage && !merchantUserFee?.fix) {
    return {
      userFeeAmount: 0,
      amountAfterUserFee: amount,
    };
  }

  const percentageFeeAmountBig = merchantUserFee?.percentage ? percentage(amount, merchantUserFee.percentage) : 0;
  const fixedFeeAmount = merchantUserFee?.fix || 0;
  const totalUserFeeAmountBig = sum([percentageFeeAmountBig, fixedFeeAmount]);

  const totalUserFeeAmount = truncateNumber(totalUserFeeAmountBig, currencyPrecision);
  const amountAfterUserFee = truncateNumber(subtract(amount, totalUserFeeAmount), currencyPrecision);

  return {
    userFeeAmount: totalUserFeeAmount,
    amountAfterUserFee,
  };
};
